import React, { useCallback, useContext, useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import axios from 'axios';
import { AuthContext } from '../../../context/Authcontext';
const base_url = process.env.REACT_APP_API_URL;


const AdminBonus = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [permit, setPermit]= useState([]);
    const [bonus, setBonus]= useState({});
    const {getRoles}= useContext(AuthContext);
    const [formData, setFormData]= useState({
        welcome:0,
        recharge:0,
        refferal:0,
        festival:0,
        weekly:0,
    });
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    
      // Toggle sidebar visibility
      const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };


      const fetchRoles= async ()=> {
        const auth= localStorage.getItem('admin');
        const role= localStorage.getItem('role');
      
        try{
          const roles= await getRoles(auth, role);
      
          roles.map((role)=>{
      
            const values= Object.values(role);
      
            values[0].map((val)=>{
      
              if(Object.keys(val).includes('bonus')){
                const permit= Object.values(val);
      
                setPermit(permit[0]);
              }
            })
            
          })
        }catch(error){
          console.log('ert',error);
        }
      }



      const handleChnage= (e)=> {
        const {name, value}= e.target;

        const validateValue= parseFloat(value.replace(/[^0-9]/g,''));
        // console.log('name:', name , 'value:', validateValue);

        setFormData({
          ...formData,
          [name]:validateValue,
        });
      };

      const handleSubmit= async(e)=> {
        e.preventDefault();

        // console.log('form',formData);

        const auth= localStorage.getItem('admin');
        const response= await axios.post(base_url + '/admin/manager/adminBonus',
          formData,
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        )

        // console.log('repsssss',response);

        if(response?.data.success){
          alert("Bonus Updated Sucessfully");
        }else{
          alert("Failed to create bonus");
        }
      }

      useEffect(()=> {

        const respon= async(req, res)=> {
            const auth= localStorage.getItem('admin');
            const respose= await axios.get(base_url+'/admin/webapi/getBonus',
                {
                    headers:{
                        'content-type':'application/json',
                        Authorization:`${auth}`
                    }
                }
            )
            // console.log('respp',respose);

            const data= respose?.data.result;
            setBonus(data[0]);
        }



        fetchRoles();
        respon();
      },[]);

      useEffect(() => {
        if (bonus) {
            setFormData({
                welcome: bonus.welcome || 0,
                recharge: bonus.recharge || 0,
                refferal: bonus.refferal || 0,
                festival: bonus.festival || 0,
                weekly: bonus.weekly || 0,
            });
        }
    }, [bonus]);


    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
      
// console.log('bn',bonus);
    return (
        <div className="wrapper">
  {/* Main Sidebar */}
  <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>Bonus Page</h1>
          </div>
        </div>
      </div>
    </section>
    <div className={`container-fluid ${permit.includes('Create Bonus')?'d-block': 'd-none'}`}>
      <div className="card">
        <div className="row">
          <div className="col-md-12">
            <form style={{padding: '10px 20px'}} onSubmit={handleSubmit}>
              <div className="form-group money">
                <label htmlFor="money">Welcome Bonus%</label>
                <input type="text" className="form-control" id="welcome" name='welcome' placeholder="Enter the amount" value={formData.welcome} onChange={handleChnage}/>
              </div>
              <div className="form-group money">
                <label htmlFor="user">Every Recharge Bonus%</label>
                <input type="text" className="form-control" id="recharge" name='recharge' placeholder="Enter the no of user" value={formData.recharge} onChange={handleChnage}/>
              </div>
              <div className="form-group money">
                <label htmlFor="money">Refferal Bonus%</label>
                <input type="text" className="form-control" id="refferal" name='refferal' placeholder="Enter the amount" value={formData.refferal} onChange={handleChnage}/>
              </div>
              <div className="form-group money">
                <label htmlFor="money">Festival Bonus%</label>
                <input type="text" className="form-control" id="festival" name='festival' placeholder="Enter the amount" value={formData.festival} onChange={handleChnage}/>
              </div>
              <div className="form-group money">
                <label htmlFor="money">Loss Back Weekly Bonus%</label>
                <input type="text" className="form-control" id="weekly" name='weekly' placeholder="Enter the amount" value={formData.weekly} onChange={handleChnage}/>
              </div>

              <button type="submit" className='btn btn-danger' id="submit" style={{width: '100%', marginTop: 26}}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>

    )
}

export default AdminBonus